module.exports = __webpack_public_path__ + "static/media/err.c6ff1bba.png";